    <template>
    <section class="hero is-fullheight">

        <div id="context_bar"></div>

        <titlePage>
            <template slot="titleBody">
                <h1 class="page-title title is-size-3">{{ $t('modules.auth.unautorized.title') }}</h1>
            </template>
        </titlePage>

        <div id="index_positions_content" class="hero flex">
            <div class="hero-body flex_content">
                <div class="container micro-container has-text-centered ">

                    <div v-if="trialExpired">
                        <div class="trial_icon">
                            <IconWarning />
                        </div>
                        <h3 class="is-size-4">{{ $t('modules.auth.unautorized.trialExpiredTitle') }}</h3>
                        <br>
                        <p v-html="$t('modules.auth.unautorized.trialExpiredNotice')"></p>
                    </div>

                    <div v-else>
                        <div class="trial_icon">
                            <IconWarning />
                        </div>
                        <h3 class="is-size-4"></h3>
                        <p v-html="$t('modules.auth.unautorized.noAccessNotice')"></p>
                    </div>

                    <span @click="goBack" class="button is-outlined is-info" >{{ $t('modules.auth.backButton') }}</span>


                </div>
            </div>
        </div>

    </section>
</template>

<script>
import TitlePage from "@/components/layouts/titlePage"

export default {
    name: 'Unautorized',
    components: {
        TitlePage
    },
    mounted(){
        
        
    },
    data(){
      return {       
        uAccess: JSON.parse(localStorage.getItem('account'))
      }
    },
    computed: {
        trialExpired(){
            return (this.uAccess.trial && this.uAccess.trial_expired)
        }
    },
    methods: {
        goBack(){
            this.$router.go(-1)
        }
    }
}

</script>

<style lang="scss">
.trial_icon{
    svg{
        width: 100px;
        fill: $danger;
    }
}
</style>
